import { DateInputProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { InputDate } from './InputDate'
import {
  InputDateValue,
  toInputDateValue,
  toDateString,
  toFullDateString
} from './utils'

// Wrap the Anatomic-style InputInteger in a FHIR adapter
export default function DateInput({
  allowPartial = false,
  error,
  inputId,
  label,
  labelComponent,
  onBlur,
  onChange,
  required,
  value,
  helperText
}: DateInputProps) {
  function handleChange(newValue: InputDateValue) {
    // When partial dates are allowed, emit YYYY or YYYY-MM as valid values.
    // When not allowed, always emit the full YYYY-MM-DD (even if incomplete)
    // so the renderer's validateDate can report the error.
    const serialized = allowPartial
      ? toDateString(newValue)
      : toFullDateString(newValue)
    onChange(serialized)
  }

  return (
    <InputDate
      errorMessage={error}
      helperText={helperText}
      label={label}
      labelComponent={labelComponent}
      name={inputId}
      required={!labelComponent && required}
      onBlur={onBlur}
      onChange={handleChange}
      value={toInputDateValue(value)}
    />
  )
}
